<div class="main-container">
@switch ($moduleName()) {
  @case ('directory') { <!-- DIRECTORIO -->
    @switch($panelName()) {
      @case ('prospects_data') { <!-- Datos del prospecto -->
        <div class="flex flex-col gap-[var(--gap-small)]">
          <app-input-text label="Clave" [isReadonly]="true" controlPosition="bottom" value="122323423421" />
          <app-input-text label="Distribuidor" [isReadonly]="true" controlPosition="bottom" value="515 Nissan demo" />
          <app-input-text label="Ejecutivo" [isReadonly]="true" controlPosition="bottom" value="Asesor de ventas" />
          <app-input-text label="Subcampaña" [isReadonly]="true" controlPosition="bottom" value="Sin definir" />
           <div class="grid grid-cols-2 gap-[var(--gap-medium)]">
            <div class="flex flex-col justify-between gap-[var(--gap-small)]">
              <p>Privacidad</p>
              <div class="flex gap-[var(--gap-small)]">
                <app-radio [isReadonly]="true" label="Sí" value="y" name="privacy" />
                <app-radio [isReadonly]="true" label="No" value="n" name="privacy" />
              </div>
            </div>
            <div class="flex flex-col gap-[var(--gap-small)]">
              <p>Temperatura</p>
              <app-input-text [isReadonly]="true" value="0%" />
            </div>
          </div>
          <app-date-picker [isReadonly]="true" label="Primer contacto" controlPosition="bottom" hostWidth="100%" [type]="'datetime-local'" [value]="today" />
          <app-date-picker [isReadonly]="true" label="Registro" controlPosition="bottom" hostWidth="100%" [type]="'datetime-local'" [value]="today" />
        </div>
      }
      @case ('communication_data') { <!-- Datos de comunicación -->
        <div>
          <p>Datos de comunicación</p>
        </div>
      }
    }
  }
}
</div>
